export function fileIdToUrl(fileId: string, downloadAttachment = true) {
  return `/data/s3-uploads/${fileId}?download=${downloadAttachment.toString()}`;
}
